import { Menu } from 'lucide-react';
import { Link, useLocation } from 'react-router';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Separator } from '@/components/ui/separator';
import { ThemeToggle } from "@/components/common/ThemeToggle";
import { useAuth } from '@/hooks';
import { useState } from 'react';

interface MobileNavProps {
  showAuth?: boolean;
}

export const MobileNav = ({ showAuth = true }: MobileNavProps) => {
  const { user } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const closeSheet = () => setOpen(false);

  const navLinks = [
    ...(user
      ? []
      : [
        { to: '/for-creators', label: 'For Creators' },
        { to: '/for-professionals', label: 'For Professionals' },
      ]),
    { to: '/features', label: 'Features' },
    { to: '/pricing', label: 'Pricing' },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="lg:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>

      <SheetContent side="right" className="w-[320px] sm:w-[350px]">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-4 mt-8">
          {/* Navigation Links */}
          <nav className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={closeSheet}
                className={`text-base font-medium py-2 px-3 rounded-md transition-colors ${isActive(link.to)
                  ? 'bg-muted text-primary'
                  : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
                  }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <Separator />

          {/* Theme Toggle */}
          <div className="flex items-center justify-between py-2 px-3">
            <span className="text-sm font-medium">Theme</span>
            <ThemeToggle />
          </div>

          <Separator />

          {/* CTA Buttons */}
          {showAuth && !user && (
            <Link to="/?auth=signup" onClick={closeSheet}>
              <Button className="w-full">Start Writing Now</Button>
            </Link>
          )}
          {showAuth && user && (
            <Link to="/app" onClick={closeSheet}>
              <Button variant="outline" className="w-full">
                Go to Dashboard
              </Button>
            </Link>
          )}
        </div>
      </SheetContent>
    </Sheet >
  );
};
